import { useQuery } from '@tanstack/react-query';
import { fetchProducts, PagedResult } from '../Services/ProductApi';
import { EntitlementProductEntity } from 'Models/Entities';
import { productKeys } from './productKeys';

export const useProductList = (page = 1, pageSize = 20) => {
	return useQuery<PagedResult<EntitlementProductEntity>, Error>({
		queryKey: productKeys.list({ page, pageSize }),
		queryFn: () => fetchProducts(page, pageSize),
	});
};
